import { ISetAdminActionTypesRedirectionAction, ActionTypes } from './AdminActionTypes.action-types';
import { IAdminActionTypesState } from './AdminActionTypes.types';

export const setAdminActionTypesRedirection = (
    data: IAdminActionTypesState
): ISetAdminActionTypesRedirectionAction => ({
    type: ActionTypes.ADMINACTIONTYPES_SET_REDIRECTION_STATE,
    data
});
